import { render } from "./MBPToggle.vue?vue&type=template&id=2a4b76e6&scoped=true"
import script from "./MBPToggle.vue?vue&type=script&lang=js"
export * from "./MBPToggle.vue?vue&type=script&lang=js"

import "./MBPToggle.vue?vue&type=style&index=0&id=2a4b76e6&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4b76e6"]])

export default __exports__